import jQuery from 'jquery';
import * as Popper from "@popperjs/core"
import {Tab} from 'bootstrap'

import lightGallery from '../lib/lightgallery/js/lightgallery.js';

var Flickity = require('flickity');
require('flickity-imagesloaded');

require('jquery-countdown');

import {settings} from './variables.js';

var baseUrl = settings.apiBaseUrl;

if (jQuery('#countdown').length){
    jQuery('#countdown').countdown('2024/01/8', function(event) {
        jQuery(this).html(event.strftime(
            '<span class="countdown__item">%-D дней</span> <span class="countdown__item">%-H часов</span> <span class="countdown__item">%M мин</span> <span class="countdown__item">%S сек</span>'
        ));
    })
}

if (jQuery('#docs_carousel').length){
    new Flickity( '#docs_carousel', {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        fullscreen: true,
        imagesLoaded: true,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 40,
            x3: 25
        }
    });
}

if (jQuery('#result_carousel').length){
    new Flickity( '#result_carousel', {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        imagesLoaded: true,
        wrapAround: true,
        lazyLoad: 2,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 40,
            x3: 25
        }
    });
}

if (jQuery('#feedback_carousel').length){
    new Flickity( '#feedback_carousel', {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        adaptiveHeight: true,
        wrapAround: true,
        arrowShape: {
            x0: 10,
            x1: 60, y1: 50,
            x2: 65, y2: 40,
            x3: 25
        }
    });
}

jQuery('.toggle-btn').click(function () {
    jQuery('.hide-collapse').not(jQuery(jQuery(this).attr('data-toggle'))).removeClass('show-collapse');
    jQuery(jQuery(this).attr('data-toggle')).toggleClass('show-collapse');
});

jQuery(document).ready(function() {

    jQuery('.plan-weeks__body').hide();
    jQuery('.plan-weeks__head').click(function() {
        jQuery(this).toggleClass('plan-weeks__head--open');
        jQuery(this).parent().find('.plan-weeks__body').toggle(300);
    });

});

jQuery(document).ready(function() {

    jQuery('.faq__answer').hide();
    jQuery('.faq__question').click(function() {
        jQuery(this).toggleClass('faq__question--open');
        jQuery(this).parent().find('.faq__answer').toggle(300);
    });

});

if (jQuery(".lightgallery").length) {
    jQuery(".lightgallery").lightGallery({
        selector: '.gallery-item-n',
        pager: false,
        download: false
    });
}